import PropTypes from 'prop-types';
import React from 'react';
import PopupContainer from '../../shared/components/PopupContainer/PopupContainer';
import Confirmation from '../components/Confirmation/Confirmation';

export default class extends React.Component {
    static propTypes = {
        reservation: PropTypes.shape({
            date: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
            time: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
            party: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        }),
        errors: PropTypes.object,
        options: PropTypes.object,
        reserveResponse: PropTypes.object,
        errorResponse: PropTypes.object,
        step: PropTypes.number,
        stepOptions: PropTypes.object,
        onClose: PropTypes.func.isRequired,
        onSave: PropTypes.func.isRequired,
        onUpdate: PropTypes.func.isRequired,
        onPublish: PropTypes.func.isRequired,
        isCustomDesign: PropTypes.bool,
        preview: PropTypes.bool,
        restaurant: PropTypes.object,
        compId: PropTypes.string
    };

    render() {
        const { form, errors, session, settings, restaurant, compId } = this.props;

        return (
            <PopupContainer {...this.props}>
                <Confirmation form={form}
                              compId={compId}
                              errors={errors}
                              session={session}
                              settings={settings}
                              restaurant={restaurant}
                              onDone={this._onDone}
                              onBack={this._onBack}
                              onValidate={this._onSmsValidation}
                              onSubmit={this._onSubmit}/>
            </PopupContainer>
        );
    }

    _onSubmit = ({reservation, errors, options}) => {
        const { onSave } = this.props;
        onSave && onSave({reservation, errors, options});
    };

    _onClose = ({reservation, errors, options}) => {
        const { onClose } = this.props;
        onClose && onClose({reservation, errors, options});
    };

    _onDone = () => {
        this.props.onClose();
    };

    _onSmsValidation = ({code}) => {
        const { onPublish } = this.props;
        onPublish && onPublish({type: 'validation', data: {code}});
    };

    _onBack = () => {
        const { onPublish } = this.props;
        onPublish && onPublish({type: 'back', data: {}});
    };
}